import { Component, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-layout-buttons',
  templateUrl: './layout-buttons.component.html',
  styleUrls: ['./layout-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class LayoutButtonsComponent {
  @HostBinding('class.layout-buttons') readonly binding = true;
}
